import React from "react"
import useStraightKey from '../hooks/useStraightKey';

export default React.memo(function StraightKey() {
    useStraightKey()
    return null
})